import config from '../../env.json';

export const SSO_TEST_FEATURE = 'externalproviders';

let localFeature = '';

interface Config {
  FEATURE?: string;
  LOCAL?: boolean;
  // add other properties as needed
}

export const isExactFeature = (featureName: string, _config: Config = config) => {
  // curch to save feature for locals.
  if (isLocal()) {
    localFeature ||= _config.FEATURE as string;
    return localFeature === featureName;
  }

  return _config.FEATURE === featureName;
};

export const isLocal = (_config: Config = config) => {
  return _config.LOCAL;
};
